export const FLAG_GETTING_CARGO_DISTANCES = 'FLAG_GETTING_CARGO_DISTANCES';
export const GET_CARGO_DISTANCES = 'GET_CARGO_DISTANCES';
export const CLEAR_CARGO_DISTANCES = 'CLEAR_CARGO_DISTANCES';
export const FLAG_CARGO_DISTANCE_ACTIVITY = 'FLAG_CARGO_DISTANCE_ACTIVITY';
export const GET_CARGO_DISTANCE = 'GET_CARGO_DISTANCE';
export const CLEAR_CARGO_DISTANCE = 'CLEAR_CARGO_DISTANCE';
